import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { isNativeShell, SERVER_ORIGIN } from "./lib/config";
import "./index.css";

const container = document.getElementById("root");
if (!container) throw new Error("index.html is missing #root");

createRoot(container).render(
	<StrictMode>
		<App />
	</StrictMode>,
);

/**
 * Registering this is what makes a browser offer "Install app" — without a
 * service worker the manifest alone only earns a bookmark.
 *
 * Not inside the native shells, which have their own launcher icon and serve
 * the page from a local origin the worker has no business caching. Comparing
 * origins catches Android too, where Capacitor serves from `https://localhost`
 * and so would otherwise look exactly like a browser.
 */
const sameOrigin = !isNativeShell && window.location.origin === SERVER_ORIGIN;
const secure = window.location.protocol === "https:" || window.location.hostname === "localhost";

if ("serviceWorker" in navigator && import.meta.env.PROD && sameOrigin && secure) {
	// After load, so it never competes with the first paint for bandwidth.
	window.addEventListener("load", () => {
		// A failure here costs nothing but the install prompt — never the app.
		navigator.serviceWorker.register("/sw.js").catch(() => {});
	});
}
